"use client"

import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from "@/components/ui/sidebar"

import {
    ArrowUpCircleIcon,
    BarChartIcon,
    CameraIcon,
    ClipboardListIcon,
    MapIcon,
    LayoutDashboard,
    BanknoteArrowUp,
    ListCheck,
    BanknoteArrowDown,
    Fuel,
    Car,
    Smartphone,
    User,
    ListIcon,
    Calendar,
    Route,
    UsersIcon,
    FileChartColumnIncreasing,
    SquarePercent,
    LayoutList,
    Component,
    CalendarSync,
} from "lucide-react"
import { useTranslate } from "react-admin";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export function TourAgentCommissionPartner() {
    const {pathname} = useLocation()
    const navigate = useNavigate()

    const translate = useTranslate();

    const data = {
        dispatch: {
            title: "Dashboard",
            navs: [
                {
                    name: "Dashboard",
                    url: "/",
                    icon: LayoutDashboard,
                },
                {
                    name: "Tours",
                    url: "/tours",
                    icon: Component,
                },
                {
                    name: "Transfers",
                    url: "/transfers",
                    icon: CalendarSync,
                },
                {
                    name: translate(`orders.name`, { smart_count: 2 }),
                    url: "/orders",
                    icon: LayoutList,
                },
            ]
        }
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.dispatch.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton onClick={() => navigate(item.url)} asChild>
                            <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
